import Button from '@/components/button';

interface Props {
  src: string;
  forName: string;
  desc: string;
  buttonName: string;
  onclick?: () => void;
}

export default function ForUserCard(props: Props) {
  return (
    <div
      className="relative mx-8 mb-8 min-h-[600px] max-w-[556px] items-center justify-center rounded-[62px] font-sans"
      style={{ boxShadow: '0px 2px 50px 0 #eff1f1' }}
    >
      <div className="flex-none">
        <img
          src={props.src}
          className="inset-0 h-full w-full object-cover"
          loading="lazy"
        />
      </div>
      <p className="mt-[47px] mb-[25px] text-center text-2xl font-bold text-[#4e4e4e]">
        {props.forName}
      </p>
      <p className="mx-[80px] text-center text-lg text-[#4e4e4e]">
        {props.desc}
      </p>
      <div className="my-12 flex items-center justify-center">
        {props.buttonName == 'Check My Profile' ? (
          <Button
            className="border-[#A9FDEE]"
            variant="normal"
            onClick={props.onclick}
          >
            {props.buttonName}
          </Button>
        ) : (
          <Button onClick={props.onclick}>{props.buttonName}</Button>
        )}
      </div>
    </div>
  );
}
